import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class ExpertCatalogueIdleModalCancelEvent extends BaseEvent {}

export class ExpertCatalogueIdleModalCancelEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof ExpertCatalogueIdleModalCancelEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('intro_offer_pop-up_cancel');
  }
}
